import { Multistep, useMultistepApi } from 'informed';

export default Multistep;
export { useMultistepApi };
